import ViewStaffDetails from '../ProfileDetails/ViewStaffDetails';
import EditStaffDetails from '../ProfileDetails/EditStaffDetails';
import { ApiIdentityOut } from '@agunity/api-v4/build/data-contracts';
import { Dispatch, SetStateAction } from 'react';
import AgLoadingCard from '../../../stories/AgLoadingCard';
import { useIntl } from 'react-intl';
import { HasOnBlurProps, ValidationListPersonalProps } from '../AddStaff/AddStaff';

export interface PageDetailsProps {
  editAccess: boolean;
  identity?: ApiIdentityOut;
  setPersonalDetails?: Dispatch<SetStateAction<ApiIdentityOut | undefined>>;
  setAgeUnknown?: Dispatch<SetStateAction<boolean>>;
  ageUnknown?: boolean;
  setHasPersonalDetailsError?: Dispatch<SetStateAction<boolean>>;
  showPersonalDetailsError?: boolean;
  hasOnBlur?: HasOnBlurProps;
  setHasOnBlur?:  Dispatch<SetStateAction<HasOnBlurProps>>;
  setValidationListPersonal?: Dispatch<SetStateAction<ValidationListPersonalProps>>;
  validationListPersonal?: ValidationListPersonalProps;
  imageURL?: string;
  // eslint-disable-next-line no-unused-vars
  onImageUpdate?: (base64?: string) => void;
  disableEmail?: boolean;
}

const Index = (
  {
    editAccess,
    identity,
    imageURL,
    onImageUpdate,
    setPersonalDetails,
    ageUnknown,
    setAgeUnknown,
    setHasPersonalDetailsError,
    showPersonalDetailsError,
    hasOnBlur,
    setHasOnBlur,
    setValidationListPersonal,
    validationListPersonal,
    disableEmail
  }: PageDetailsProps
) => {
  const messages = useIntl().formatMessage;

  return (
    !identity
      ? <AgLoadingCard text={messages({ id: 'LOADING' })} />
      : editAccess
        ? <EditStaffDetails
          setPersonalDetails={setPersonalDetails}
          identity={identity}
          imageURL={imageURL}
          onImageUpdate={onImageUpdate}
          ageUnknown={ageUnknown}
          setAgeUnknown={setAgeUnknown}
          setHasPersonalDetailsError={setHasPersonalDetailsError}
          showPersonalDetailsError={showPersonalDetailsError}
          hasOnBlur={hasOnBlur}
          setHasOnBlur={setHasOnBlur}
          validationListPersonal={validationListPersonal}
          setValidationListPersonal={setValidationListPersonal}
          disableEmail={disableEmail}
        />
        : <ViewStaffDetails identity={identity} imageURL={imageURL} />
  );
};

export default Index;